import React from 'react';
import { FormattedMessage } from 'react-intl';
import { PerformerNamesList } from '../PerformerNamesList';
import styles from './PerformersList.module.scss';

type PerformersListProps = {
  headliners: string[];
  supporters: string[];
  shouldShowHeadlinersTitle: boolean;
  shouldShowSupportersTitle: boolean;
  isHidden?: boolean;
  'data-testid'?: string;
};

export const PerformersList: React.FC<PerformersListProps> = ({
  headliners,
  supporters,
  shouldShowHeadlinersTitle,
  shouldShowSupportersTitle,
  isHidden = false,
  'data-testid': dataTestId,
}) => {
  const containerClassName = isHidden ? styles.visuallyHidden : undefined;
  const headlinersTitleClassName = shouldShowHeadlinersTitle
    ? styles.title
    : `${styles.title} ${styles.visuallyHidden}`;

  return (
    <div className={containerClassName} data-testid={dataTestId} aria-hidden={isHidden || undefined}>
      {headliners.length > 0 && (
        <>
          <h3 className={headlinersTitleClassName}>
            <FormattedMessage id="Headliners" defaultMessage="Headliners" description="Headliners list title" />
          </h3>
          <PerformerNamesList names={headliners} keyPrefix="headliner" />
        </>
      )}

      {supporters.length > 0 && (
        <>
          {shouldShowSupportersTitle && (
            <h3 className={styles.title}>
              <FormattedMessage
                id="More Performers"
                defaultMessage="More Performers"
                description="Additional performers list title"
              />
            </h3>
          )}
          <PerformerNamesList names={supporters} keyPrefix="supporter" />
        </>
      )}
    </div>
  );
};
